import { render } from "./ForgotPassword.vue?vue&type=template&id=7f5bd9dd&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=7f5bd9dd&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/RACINGBIKE/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5bd9dd"]])

export default __exports__